import { useMutation } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_MESSAGE } from '../../../../../actions/actionTypes';
import { updateUserBestInDental } from '../../../../../services/users';
import { showErrorMessage } from '../../../../../utils';
import { UserType } from '../../../../../enums/UserType';

export const usePromotions = () => {
  const currentUser = useSelector((state) => state.users.currentUser);

  const dispatch = useDispatch();

  const bestInDental = useMemo(() => {
    if (currentUser?.user_type === UserType.DNT) {
      return currentUser?.office_info?.bestInDental;
    }

    return currentUser?.professional_info?.bestInDental;
  }, [currentUser]);

  const [formValue, setFormValue] = useState(bestInDental?.status || 'not-entered');

  const { mutate } = useMutation({
    mutationFn: (status) => updateUserBestInDental(currentUser.id, { status }),
    meta: {
      skipGlobalErrorToaster: true,
    },
    onSuccess: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          message: 'Contest Status Successfully Updated',
        },
      });
    },
    onError: () => {
      showErrorMessage({ message: 'You are not allowed to perform this action.' });
      setFormValue(bestInDental?.status || 'not-entered');
    },
  });

  const handleStatusChanged = (value) => {
    setFormValue(value);
    mutate(value);
  };

  return {
    formValue,
    handleStatusChanged,
    options: [
      {
        label: 'Not Entered',
        value: 'not-entered',
      },
      {
        label: 'Nominees',
        value: 'nominee',
      },
      {
        label: 'Applicants',
        value: 'applicant',
      },
      {
        label: 'Winner',
        value: 'winner',
      },
      {
        label: 'Rejected',
        value: 'rejected',
      },
    ],
  };
};
